import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Platforms from "@/pages/Platforms";
import PlatformDetail from "@/pages/PlatformDetail";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import ClientsApply from "@/pages/ClientsApply";
import CaseStudies from "@/pages/CaseStudies";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen bg-black flex items-center justify-center text-zinc-600 font-mono text-sm">Loading…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={withLayout(<Home />)} />
            <Route path="/platforms" element={withLayout(<Platforms />)} />
            <Route path="/platforms/:slug" element={withLayout(<PlatformDetail />)} />
            <Route path="/about" element={withLayout(<About />)} />
            <Route path="/services" element={withLayout(<Services />)} />
            <Route path="/contact" element={withLayout(<Contact />)} />
            <Route path="/clients/apply" element={withLayout(<ClientsApply />)} />
            <Route path="/case-studies" element={withLayout(<CaseStudies />)} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="*" element={withLayout(<Home />)} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
